import { render, staticRenderFns } from "./rakuMessaging.vue?vue&type=template&id=06fd7684&scoped=true&"
import script from "./rakuMessaging.vue?vue&type=script&lang=js&"
export * from "./rakuMessaging.vue?vue&type=script&lang=js&"
import style0 from "./rakuMessaging.vue?vue&type=style&index=0&id=06fd7684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06fd7684",
  null
  
)

export default component.exports